<template>
  <div>
    <TopHeader2 underlineItem="وبلاگ"></TopHeader2>
    <section class="logo-header-resp d-md-none my-5">
      <div class="mx-auto">
       <router-link to="/">
          <img src="@/assets/images/logos/logoBlack.png" alt="" />
       </router-link>
      </div>
    </section>
    <main class="main">
      <PagesPath
      v-if="blog"
        :items="['مقالات', blog.title]"
        :last="'/weblogs'"
      ></PagesPath>
      <div class="container">
        <section v-if="blog" class="text-right">
          <div class="weblog-top mb-4">
            <div class="text-right">
              <h6
                class="fontsize-heavy text-color-444 weight-bold py-md-5 pb-5 border-bottom"
              >
                {{ blog.title }}
              </h6>
              <section class="my-3">
                <h6 class="text-secondary fontsize-small">کلمات کلیدی:</h6>
                <div class="pr-2 my-3">
                  <p
                    class="text-secondary fontsize-small"
                    v-for="(tag, index) in blog.tags"
                    :key="index"
                  >
                    <router-link :to="`/weblogs?tag=${tag.id}`">
                      {{ tag.title }}
                    </router-link>
                  </p>
                </div>
              </section>
            </div>
            <div class="p-3">
              <div class="w-100">
                <img
                  v-if="blog.cover == null"
                  src="@/assets/images/internalWeblog/weblogImg1.png"
                  class="w-100"
                  alt=""
                />
                <img
                  v-else
                  :src="blog.cover.url"
                  class="w-100"
                  :alt="blog.title"
                />
              </div>
            </div>
          </div>
          <div v-html="blog.body"></div>
        </section>
        <loader v-else />
        <section class="my-5 py-5">
          <form @submit.prevent="sendComment()">
            <div class="contact-grid fontsize14">
              <input
                v-model="name"
                class="bg-white border-radius10 border px-3 py-2"
                type="text"
                placeholder="نام و نام خانوادگی:"
              />
              <input
                v-model="email"
                class="bg-white border-radius10 border px-3 py-2"
                type="text"
                placeholder="ایمیل:"
              />
            </div>
            <textarea
              v-model="body"
              class="bg-white border-radius10 border px-3 py-2 w-100 mt-3"
              name=""
              id=""
              cols="30"
              rows="10"
              placeholder="دیدگاه خود را وارد کنید:"
            ></textarea>
            <div
            id="buttons"
              class="d-flex justify-content-between align-items-baseline mt-3 fontsize14"
            >
              <div class="contact-text ml-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.9999 2.75021C17.1089 2.75021 21.2499 6.89221 21.2499 12.0002C21.2499 17.1082 17.1089 21.2502 11.9999 21.2502C6.89188 21.2502 2.74988 17.1082 2.74988 12.0002C2.74988 6.89221 6.89188 2.75021 11.9999 2.75021Z"
                    stroke="#999"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.995 8.20432V12.6233"
                    stroke="#999"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M11.995 15.7961H12.005"
                    stroke="#999"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span
                  :class="{ error: messageStatus == 'error' }"
                  class="fontsize13 text-color-999 mr-1"
                >
                  {{ messageText }}
                </span>
              </div>
              <button
                class="bg-btn-hover bg-color-theme border-radius10 px-3 py-2 text-white"
                type="submit"
         
              >
               ثبت دیدگاه
              </button>
            </div>
          </form>
        </section>
    <Title v-if="blogComment.length>0" class="photos-gallery-title" title="دیدگاه ها"></Title>

        <section>
          <div v-if="blogComment" id="commentSection">
            <template v-for="(comment, index) in blogComment">
              <div class="comment" :key="index">
                <div class="commentBox">
                  <div>
                    <h4>{{ comment.user_name }}</h4>
                    <p>
                      <span>زمان انتشار : </span>
                      <span>{{
                        new Date(comment.created_at).toLocaleDateString("fa")
                      }}</span>
                    </p>
                  </div>
                    <p class="commentBody">
                      {{ comment.body }}
                    </p>
                </div>
              </div>
              <div v-if=" comment.all_children.length>0" class="answer" :key="index + 'ans'">
                  <div class="commentBox">
                  <div>
                    <h4>پاسخ مدیر</h4>
                    <p>
                      <span>زمان انتشار : </span>
                      <span>{{
                        new Date(comment.all_children[0].created_at).toLocaleDateString("fa")
                      }}</span>
                    </p>
                  </div>
                    <p class="commentBody">
                      {{ comment.all_children[0].body }}
                    </p>
                </div>
              </div>
            </template>
          </div>
        </section>
      </div>
    </main>
  </div>
</template>

<script>
import Title from "@/components/Title.vue";

import TopHeader2 from "../components/TopHeader2";
import PagesPath from "../components/PagesPath";
import loader from "@/components/loader.vue";

export default {
  name: "InternalWeblog",
  components: {
    loader,
    TopHeader2,Title,
    PagesPath
  },
  mounted() {
    this.$axios
      .get(`/posts?postId=${this.$route.params.id ? this.$route.params.id : 1}`)
      .then((response) => {
        this.blog = response.data.data.post;
        this.blogComment = response.data.data.comments;
        console.log(response);
      });
  },
  data() {
    return {
      blog: null,
      blogComment: null,
      name: "",
      email: "",
      body: "",
      messageStatus: "success",
      messageText: "پیام شما پس از تایید در همین صفحه نمایش داده میشود"
    };
  },
  methods: {
    validateEmail(email) {
      var re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    sendComment() {
      if (this.name.length < 5) {
        this.messageStatus = "error";
        return (this.messageText = "نام خود را به صورت کامل وارد کنید");
      } else if (!this.validateEmail(this.email)) {
        this.messageStatus = "error";
        return (this.messageText = "ایمیل خود را با فرمت درست وارد کنید");
      } else if (this.body.length < 2) {
        this.messageStatus = "error";
        return (this.messageText = "نظر خود را به صورت کامل وارد کنید");
      } else {
        this.messageStatus = "success";
        this.messageText = "پیام شما پس از تایید در همین صفحه نمایش داده میشود";
      }
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("post_id", this.$route.params.id);
      formData.append("body", this.body);
      this.$axios.post("comment", formData).then(() => {
        const options = { title: "سپاس از شما", size: "sm" };
        this.$dialogs.alert("نظر شما دریافت شد", options);
        this.name = "";
        this.email = "";
        this.body = "";
      });
    }
  },
  
     metaInfo() {
    return {
      title:this.blog?this.blog.title:"پست",
      meta: [
        {
          name: "description",
          content:this.blog?this.blog.meta_description:""
        },
      ]
    };
  },
};
</script>

<style scoped>
.logo-header-resp > div {
  width: 150px;
}
.logo-header-resp > div img {
  width: 100%;
}
.weblog-top {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 1rem;
}
.internal-web-img {
  border-radius: 10px;
  overflow: hidden;
  width: 55%;
}
.internal-web-img img {
  width: 100%;
}
.contact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
button[type="submit"] {
  width: 25%;
  margin: auto;
}
@media screen and (max-width: 767px) {
  .weblog-top {
    grid-template-columns: 1fr;
  }
  #buttons{
    display: flex !important;
    flex-direction: column;
    justify-content: center !important;
    align-content: center !important;
  }
.contact-text{
    width: 50%;
    margin: 10px auto !important;
    text-align: center;
}
  .contact-grid {
    grid-template-columns: 1fr;
  }
  button[type="submit"] {
    width: 50%;
    margin: auto;
  }
}
.error {
  color: red;
}
.commentBox div {
    display: flex;
    width: 100%;
    justify-content: space-between;
}
.commentBox {
    display: flex;
    margin: 15px 0;
    flex-direction: column;
    align-items: flex-start;
    background: white;
    box-shadow: 0 0 10px #00000054;
    padding: 15px;
    border-radius: 15px;
}
.answer {
    width: 95%;
    margin-right: 10%;
    background: transparent;
}
.answer .commentBox{
  box-shadow: 0 0 20px #30504f;

}
.commentBody{
  padding: 0 30px;
}
</style>
